import { useState, useEffect, useRef } from 'react';
import { copyToClipboard } from '../../../../utils/clipboard';
import type { BoletoPaymentViewProps } from '../types/boleto-payment.types';

export const useBoletoPayment = (props: BoletoPaymentViewProps) => {
  const [codeCopied, setCodeCopied] = useState(false);
  const hasNotified = useRef(false);

  const handleCopyCode = async (codeToCopy?: string) => {
    const code = codeToCopy || props.paymentDetails.digitableLine || props.paymentDetails.paymentCode;
    if (!code) {
      alert('Código do boleto não disponível para cópia.');
      return;
    }

    const success = await copyToClipboard(code);
    if (success) {
      setCodeCopied(true);
      setTimeout(() => setCodeCopied(false), 2000);
    } else {
      alert('Falha ao copiar o código do boleto. Por favor, tente manualmente.');
    }
  };

  // Notificar venda para Shopify se os dados estiverem disponíveis (apenas uma vez)
  useEffect(() => {
    if (props.shopifyData && !hasNotified.current) {
      hasNotified.current = true;
      // notifySaleToBackend(props.shopifyData);
    }
  }, [props.shopifyData]);

  return {
    codeCopied,
    handleCopyCode,
  };
};
